module.exports = __webpack_public_path__ + "static/media/me_2023_zoomed.e3a18889.jpeg";